import { ReservationInputComponentModule } from '@b2b/common/components/reservation-input';
import { CounterDirectiveModule } from '@b2b/common/directives/counter';
import { EmailOptionsDirectiveModule } from '@b2b/common/directives/emailOptions';
import { SimpleFormInputDirectiveModule } from '@b2b/common/directives/simpleFormInput';
import { LoadACMECheckoutResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { IInjectable, StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersCheckoutControllerModule } from './controllers/OrdersCheckoutController';

function EventDataResolver(): IInjectable {
  return [
    '$stateParams',
    'ApiService',
    function ($stateParams: StateParams, ApiService: ApiService) {
      if ($stateParams.accountId && $stateParams.eventId) {
        return ApiService.partners.reseller.event({
          accountId: $stateParams.accountId,
          eventId: $stateParams.eventId,
        });
      }

      if ($stateParams.eventId) {
        return ApiService.program.instances.detail($stateParams.eventId);
      }

      return { data: { success: false } };
    },
  ];
}

export const OrdersCheckoutView = angular
  .module('acme.view.application.orders.checkout', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    CounterDirectiveModule,
    EmailOptionsDirectiveModule,
    ReservationInputComponentModule,
    SimpleFormInputDirectiveModule,
    OrdersCheckoutControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.orders.checkout',
      url: '/checkout?customerId&accountId&accountContactId&orderRequestItemIds&eventId',
      views: {
        'subview-main': {
          controller: 'OrdersCheckoutController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/checkout/checkout.tpl.html',
        },
      },
      data: {
        pageTitle: 'Complete Order',
      },
      resolve: {
        EventData: EventDataResolver(),
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
      },
    });
  }).name;
